import React from 'react';
import Global_var from "../utils/Global_var";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import "./dashboard.css";
import { Checkbox } from '@mui/material';
function Dashboard () {

  const [socket, setSocket] = useState();
  const [room, setRoom] = useState([]);
  const [connectNb, setConnectNb] = useState();
  const [sessionNb, setSessionNb] = useState();
  const [Max, setMax] = useState({});
  const [lapNb, setLapNb] = useState();
  const [SocketData, setSocketData] = useState({});
  const [Error,setError] = useState('');
  const [servError,setservError] = useState([]);
  const [RoomList, setRoomList] = useState(true);
  const [ErrorList, setErrorList] = useState(true);
  const [Checkbox, setCheckbox] = useState(true);
  
  useEffect(() => {
    //setup socket.io
    const s = io(Global_var.live_server);
    setSocket(s);

    return () => {
      s.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {     
      socket.on("connect", () => {
        socket.emit("connectAdmin", {}, (res) => {
          if (res.status !== 200) {
            setError(res.message);
          } else {
            setError("");
            setRoom(res.data?.rooms || {});
            setMax(res.data?.Max || {});
            setConnectNb(res.data?.ViewerConnectNb || 0);
            setSessionNb(res.data?.CreateSessionNb || 0);
            setLapNb(res.data?.LapNb || 0);
            setservError(res.data?.servError || []);
          }
        });
      });
      socket.on("updateRooms",(res) => {
        if (res.status !== 200) {
          setError(res.message);
        } else {
          setError("");
          setRoom(res.data.rooms);
          setMax(res.data.Max);
        }
      });
    }
  }, [socket]);

  const RAZmax = ()=>{
    socket.emit("RAZmax", {}, (res) => {
      res.status==200 && setMax(res.data.Max)
    });
  }

  const handleChangeButtonRoom = () => {
    setRoomList(!RoomList)
  }

  const handleCheckboxChange = () => {
    setCheckbox(!Checkbox)
  }

  const getAllViewer = () => {
    var viewerNB=0;
    room?.map((data)=>{
      viewerNB = viewerNB + data.viewerConnect
    })
    return viewerNB
  } 
  room.sort((x, y) => {
    return y.viewerConnect - x.viewerConnect;
  });
  room.sort((x, y) => {
    // true values first
    return ((x.ProducerIsActive === y.ProducerIsActive)? 0 : x.ProducerIsActive? -1 : 1);
  });
  console.log(room)
    return (     
      <div className='wrap'>
      {RoomList ? ErrorList ? <div>
        <div className='table_admin'> 
          <div className='table_title'>Nombre de room en cours:</div>
          <div className='table_row border_bottom'>
            <div>Source</div>
            <div>{room.filter((room)=>room.ProducerIsActive).length}</div>
          </div>
          <div className='table_row'>
            <div><p>Viewer</p></div>
            <div>{getAllViewer()}</div>
          </div>
          <div className='table_title'>Depuis demarage du serveur:</div>
          <div className='table_row border_bottom'>
            <div>room crées total</div>
            <div>{room.length}</div>
          </div>
          <div className='table_row border_bottom'>
            <div>sessions "source"</div>
            <div>{sessionNb}</div>
          </div>
          <div className='table_row border_bottom'>
            <div>sessions "viewer"</div>
            <div>{connectNb}</div>
          </div>
          <div className='table_row'>
            <div>tours comptés</div>
            <div>{lapNb}</div>
          </div>
          <div className='table_row'>
            <div>Erreurs 500</div>
            <div>{servError?.length || 0} {servError?.length>0&&<button onClick={()=>{setErrorList(false)}}>détail</button>}</div>
          </div>
          <div className='table_title'>Depuis demarage du serveur ou RAZ:<button onClick={()=>{RAZmax()}}>RAZ</button></div>
          <div className='table_row border_bottom'>
            <div>room "ouvertes" en "source" MAX</div>
            <div>{Max.roomMax}</div>
          </div>
          <div className='table_row'>
            <div>"viewer" MAX</div>
            <div>{Max.viewerMax}</div>
          </div>
        </div>        
        <button onClick={() => {handleChangeButtonRoom()}} className='button_liste_room orangeButton BasicButton'>Rooms ouvertes en cours</button>
        </div> : <div>
            <button id='DriverDetails_back'
              onClick={() => {setErrorList(true)}}>
              <ArrowBackIosIcon sx={{ fontSize: '15px' }} /> back
            </button> {servError[0] && servError.map((error,i1)=>(
          <div key = {i1}>
          <h2>Erreur N°{i1+1}</h2>
          <div><b>Message d'erreur : </b> {error.msg}</div>  
          <div><b>Data d'erreur : </b> {JSON.stringify(error.dataError)}</div>  
          </div>
          ))} </div> : 
        <div>
        <div className='RoomList_header'>
            <button id='DriverDetails_back'
              onClick={() => {handleChangeButtonRoom()}}>
              <ArrowBackIosIcon sx={{ fontSize: '15px' }} /> back
            </button>
            <h2>Rooms ouvertes en cours</h2>
            <div></div>
        </div>
        <table className="table_room_list">
              <thead>
                <tr>
                  <td><p>Room id</p>
                    <div className="table_room_list_checkbox">
                      {Checkbox ? 
                      <input checked type="checkbox" onClick={() => {handleCheckboxChange()}}></input>
                        : <input type="checkbox" onClick={() => {handleCheckboxChange()}}></input>
                        }
                      Only Active</div>
                  </td>
                  <td>Name</td>
                  <td>Statut</td>
                  <td>Drivers</td>
                  <td>Viewers</td>               
                </tr>
              </thead>
              <tbody>
              {room?.[0] && room?.filter((room) => Checkbox ? room.ProducerIsActive === true : true).map((room, i1) => (
                    <tr onClick={()=>{window.open(document.location.href.replace('dashboard','').concat(room?.roomID),'_blank');}}>
                      {room.ProducerIsActive ? 
                      <td style={{backgroundColor: '#adffb4'}}>{room?.roomID || '-'}</td>
                      :<td style={{backgroundColor: '#ffbfad'}}>{room?.roomID || '-'}</td>
                      }
                      <td>{room?.SessionData?.races?.[0]?.name || '-'}</td>
                      <td>{room?.SessionData?.state?.[room?.SessionData?.state.length - 1]?.status || '-'}</td>
                      <td>{room?.SessionData?.races?.[0]?.drivers.length || '-'}</td>
                      <td>{room?.viewerConnect || '-'}</td>
                    </tr>
                    ))}
              </tbody>
            </table>
        </div>}
      </div>    
    );

}

export default Dashboard ;